module.exports = __webpack_public_path__ + "static/media/p2.ae37d618.jpg";